<template>
    <div class="row">
        <FormGroup :label="$t('labels.user_name')" class="col-lg-4">
            <Input v-model="login"/>
        </FormGroup>
        <FormGroup :label="$t('labels.password')" class="col-lg-4">
            <Input v-model="password" type="password"/>
        </FormGroup>
        <FormGroup :label="$t('labels.company_number_creating_enabled')" class="col-lg-4">
            <AppSwitch v-model="companyNumberCreatingEnabled"/>
        </FormGroup>
    </div>
    <template v-if="companyNumberCreatingEnabled">
        <AppFieldset :title="$t('labels.shipment_details')">
            <div class="row">
                <FormGroup :label="$t('labels.type')" class="col-lg-2" required>
                    <AppSelect
                        @update:model-value="senderType = $event"
                        :model-value="senderType?.key"
                        :selected-value="senderType?.name"
                        :options="senderTypes"
                        option-key="key"
                        option-value="name"
                    />
                </FormGroup>
                <FormGroup :label="$t('labels.full_name')" class="col-lg-2" required>
                    <Input v-model="senderName"/>
                </FormGroup>
                <FormGroup :label="$t('labels.phone')" class="col-lg-2" required>
                    <Input v-model="senderPhone" placeholder="380991112233"/>
                </FormGroup>
                <FormGroup :label="$t('labels.city')" class="col-lg-2" required>
                    <AppAutoComplete
                        :url="`/projects/${$route.params.projectUuid}/crm/delivery/providers/${DeliveryIntegrationsEnum.ROZETKA}/cities`"
                        :model-value="city?.uuid"
                        :selected-value="formatDeliveryCityName(city)"
                        @update:model-value="(newCity) => {city = newCity; warehouse = null}"
                        :query-params="{
                            orders: [
                                { column: 'name', dir: 'asc'}
                            ]
                        }"
                    >
                        <template #optionItem="{option}">
                            {{ formatDeliveryCityName(option) }}
                        </template>
                    </AppAutoComplete>
                </FormGroup>
                <FormGroup :label="$t('labels.department')" class="col-lg-4" required>
                    <AppAutoComplete
                        :url="`/projects/${$route.params.projectUuid}/crm/delivery/providers/${DeliveryIntegrationsEnum.ROZETKA}/cities/${city?.uuid}/warehouses`"
                        :model-value="warehouse?.uuid"
                        :selected-value="warehouse?.name"
                        :disabled="!city"
                        @update:model-value="warehouse = $event"
                        :query-params="{
                            orders: [
                                { column: 'name', dir: 'asc'}
                            ]
                        }"
                    />
                </FormGroup>
            </div>
        </AppFieldset>
        <AppFieldset :title="$t('labels.cargo_details')">
            <div class="row">
                <FormGroup :label="$t('labels.seats_amount')" class="col-lg-2 col-md-4">
                    <Input v-model="dimensions.seats_amount" type="number"/>
                </FormGroup>
                <FormGroup :label="$t('labels.weight')" class="col-lg-2 col-md-4">
                    <Input v-model="dimensions.weight" type="number"/>
                </FormGroup>
                <FormGroup :label="$t('labels.length')" class="col-lg-2 col-md-4">
                    <Input v-model="dimensions.length" type="number"/>
                </FormGroup>
                <FormGroup :label="$t('labels.width')" class="col-lg-2 col-md-4">
                    <Input v-model="dimensions.width" type="number"/>
                </FormGroup>
                <FormGroup :label="$t('labels.height')" class="col-lg-2 col-md-4">
                    <Input v-model="dimensions.height" type="number"/>
                </FormGroup>
            </div>
        </AppFieldset>
    </template>
</template>
<script>
import FormGroup from '../../../../../components/new/form/group/FormGroup.vue';
import Input from '../../../../../components/new/form/Input.vue';
import AppSelect from '../../../../../components/new/form/select/AppSelect.vue';
import AppSwitch from '../../../../../components/new/form/switch/AppSwitch.vue';
import AppAutoComplete from '../../../../../components/new/form/autocomplete/AppAutoComplete.vue';
import AppFieldset from '../../../../../components/new/AppFieldset.vue';

import { DeliveryIntegrationsEnum } from '../../../../enums/DeliveryIntegrationsEnum';
import { RozetkaSenderTypeEnum } from '../../../../enums/RozetkaSenderTypeEnum';
import { formatDeliveryCityName } from '../../../../../utils';
import { makeSenderCity, makeSenderWarehouse, makeDimensionsForm, buildDimensions, buildSenderAddressFields } from './senderDefaultFields';

export default {
    name: "RozetkaCredentialFields",
    components: {
        FormGroup, Input, AppSelect, AppSwitch, AppAutoComplete, AppFieldset
    },
    props: {
        credential: {
            type: Object,
            default: null
        }
    },
    data() {
        let settings = this.credential?.settings ?? {};
        let defaultFields = settings.default_fields ?? {};

        let senderTypes = [
            {
                key: RozetkaSenderTypeEnum.NATURAL,
                name: this.$t(`enums.RozetkaSenderTypeEnum.${RozetkaSenderTypeEnum.NATURAL}`)
            },
            {
                key: RozetkaSenderTypeEnum.LEGAL,
                name: this.$t(`enums.RozetkaSenderTypeEnum.${RozetkaSenderTypeEnum.LEGAL}`)
            }
        ];

        let dimensions = makeDimensionsForm(defaultFields);

        if (dimensions.seats_amount === '') {
            dimensions.seats_amount = 1;
        }

        return {
            DeliveryIntegrationsEnum,
            login: this.credential?.login ?? '',
            password: this.credential?.password ?? '',
            companyNumberCreatingEnabled: settings.company_number_creating_enabled ?? false,
            senderTypes,
            senderType: senderTypes.find(senderType => senderType.key === defaultFields.sender_type) ?? null,
            senderName: defaultFields.sender_name ?? '',
            senderPhone: defaultFields.sender_phone ?? '',
            city: makeSenderCity(defaultFields),
            warehouse: makeSenderWarehouse(defaultFields),
            dimensions
        };
    },
    methods: {
        formatDeliveryCityName,
        buildRequest() {
            let request = {
                login: this.login,
                password: this.password,
                settings: {
                    ...this.credential?.settings,
                    company_number_creating_enabled: this.companyNumberCreatingEnabled,
                    default_fields: {
                        ...this.credential?.settings?.default_fields,
                        ...buildSenderAddressFields(this.city, this.warehouse),
                        sender_type: this.senderType?.key ?? null,
                        sender_name: this.senderName || null,
                        sender_phone: this.senderPhone || null,
                        dimensions: buildDimensions(this.dimensions)
                    }
                }
            };

            return request;
        }
    }
}
</script>
